module.exports = __webpack_public_path__ + "static/media/about2.837089ad.jpg";